var XPortal = XPortal || {};
XPortal.Format = (function () {
    var self = { alertTemplate: null, trendTemplate: null, tagsTemplate: null, valueSeparator: "_#_" };
    self.Link = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings && opts.settings.url) {
            html = getLinkHtml(opts, {});
            return self.WrapCellExtended(html, item, nodeId, dfield);
        }
        html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.Alert = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings) {
            const r = getAlertModel(opts);
            const tmplHtml = htmlTemplate || (self.alertTemplate || (self.alertTemplate = $("#gridAlertTemplate").html()));
            html = processTemplate(tmplHtml, null, r, nodeId, dfield);
            return self.WrapCellExtended(html || "", item, nodeId, dfield);
        }
        html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.Percent = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        if (opts.settings) {
            const r = getPercentModel(opts);
            const bdefault = r.vitems.length < 1 && !(r.color || r.bgcolor);
            if (bdefault) r.html = XPortal.Utils.RenderHtmlPercentBar("30%", r.percent);
            else {
                let citem = Object.assign({}, item, r);
                r.title = r.title ? processTemplate(r.title, '', citem, nodeId, dfield) : "";
                var pp = r.vitems.filter(v => v.maxVal >= r.percent);
                if (pp.length > 1) pp = pp.filter(v => (isNaN(Number(v.min)) ? 0 : v.min) <= r.percent);
                if (pp.length < 1) {
                    if (bdefault) r.html = XPortal.Utils.RenderHtmlPercentBar("30%", r.percent);
                    else r.html = processTemplate(r.defHtml, r.value, citem, nodeId, dfield);
                } else {
                    citem = Object.assign(citem, pp[0]);
                    r.html = processTemplate(pp[0].html, pp[0].value, citem, nodeId, dfield);
                }
            }
            return self.WrapCellExtended(r.html, item, nodeId, dfield);
        }
        let html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    //Builds the trend indicator of a dashboard cue tile out of the setup the server put into its data-trend attribute.
    //Works like self.Percent, but one level up: self.Percent formats a field of a record, this one formats a whole tile.
    self.Trending = function (setup, item, nodeId, dfield) {
        if (!setup) return "";
        const opts = { item: item || {}, nodeId: nodeId, dfield: dfield || "trend", settings: setup };
        const r = getTrendingModel(opts);
        const rule = r.vitems.find(v => isTrendInRule(v, r.value)) || null;
        //the sign always travels with the value - it is never a separate, optional token a template can leave out
        const displayValue = (r.value > 0 ? "+" : "") + r.value;
        const model = Object.assign({}, opts.item, r, rule || {}, { value: displayValue });

        //a rule overrides the templates of the trend, the same way a conditional formatting rule overrides the ones of the tile
        const html = processTemplate((rule && rule.html) || r.html || r.defHtml, displayValue, model, opts.nodeId, opts.dfield) || "";
        const tooltip = (processTemplate((rule && rule.tooltip) || r.tooltip, displayValue, model, opts.nodeId, opts.dfield) || "").trim();

        //the markup of the badge lives in CommonTemplates.cshtml, the same way the alert format keeps its own
        const tmplHtml = self.trendTemplate || (self.trendTemplate = $("#tileTrendTemplate").html());
        if (!tmplHtml) {
            console.warn("#tileTrendTemplate is not on the page - CommonTemplates.cshtml looks outdated, the trend is skipped.");
            return "";
        }

        const icon = rule && rule.icon ? rule.icon : null;
        const color = toCssColor(rule && rule.color);
        const bgColor = toCssColor(rule && rule.bgcolor);

        return processTemplate(tmplHtml, null, {
            direction: r.direction,
            styleCss: color ? "color:" + color + ";" : "",
            hasIcon: !!icon,
            iconCss: icon || "",
            iconStyleCss: bgColor ? "background-color:" + bgColor + ";" : "",
            valueHtml: html,
            hasTooltip: tooltip.length > 0,
            tooltip: tooltip
        }, opts.nodeId, opts.dfield) || "";
    };
    self.TrimSeparators = function (str, separator, subst) {
        separator = separator || ",";
        subst = subst || separator + " ";
        if (!str || !str.length) return str;
        str = str.trim();
        const regex = /(\,\s+)+/gm;
        // const regex = new RegExp('(\\,\\s+)+', 'gm');
        const result = str.replace(regex, subst);
        return result;
    };
    self.FormatMultipleValue = function (value) {
        if (typeof value !== "string" || value.indexOf(XPortal.GridInlineEditing.ValueSeparator) === -1) return value;
        return value.replace(getValueSeparatorRegExp(), XPortal.Grid.multipleValueGridSeparator);
    };
    self.Custom = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        const opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        if (opts && opts.settings && opts.settings.formula && opts.settings.formula.includes('(') && opts.settings.formula.includes(')')) {
            try {
                const funcContext = { item, dtype, dfield, inFormat, nodeId, htmlTemplate, value: item[dfield.toLowerCase()], opts, fOpts };
                return processFunction(funcContext);
            } catch (ex) { }
        }
        const tplt = opts.settings ? (opts.settings.formula || opts.settings.title) || "[[" + dfield + "]]" : "[[" + dfield + "]]";
        return self.FormatMultipleValue(processTemplate(tplt, item[dfield.toLowerCase()], item, nodeId, dfield));
    };
    self.FormattingRules = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        const opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings) {
            html = getFormattingRulesHtml(opts, item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts);
            return self.WrapCellExtended(html, item, nodeId, dfield);
        }
        html = processTemplate(`[[${dfield}]]`, null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };

    self.GetLinkHtml = function (opts, lnkStgs) {
        return getLinkHtml(opts, lnkStgs);
    };

    self.ProcessTemplate = function (inFormat, fvalue, doc, nodeId, dfield) {
        return processTemplate(inFormat, fvalue, doc, nodeId, dfield)
    };
    self.Tags = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        const tags = item[dfield.toLowerCase()] || [];
        let dTags = "";
        if (tags.length)
            dTags = item[dfield.toLowerCase()] = tags.split(',').join(self.valueSeparator);
        const grCode = XPortal.Template.ReplaceFormatString(opts.settings.groupcode, null, item, {});
        let isEditable = true;

        var modelName = XPortal.Store.GetModelByNodeId(nodeId);
        if (modelName && modelName.length && modelName.startsWith("GM.")) {
            var model = XPortal.Store.GetModelByName(modelName);
            var grid = model.GridModel;
            var col = grid.columns.find(x => x.field.toLowerCase() == dfield.toLowerCase()) || {};
            isEditable = col.cancreateorg || col.caneditorg;
        }
        if (opts.settings) {
            let stts = opts.settings;
            stts.tags = dTags;
            stts.grCode = grCode;
            stts.uniqueId = item.UniqueId;
            stts.nodeId = opts.nodeId;
            stts.dField = dfield;
            stts.entityAlias = item.EntityAlias;
            stts.addbtn = isEditable;
            const template = self.tagsTemplate || (self.tagsTemplate = XPortal.Template.GetCompiledTemplate($("#tagsGridFormat").html()));
            return self.WrapCellExtended(template(stts), item, nodeId, dfield);
        }
        const html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };

    self.WrapCellExtended = function (content, data, nodeId, field) {
        return "<span class=\"tdcell tdcell-extended\">" + content + "</span>";
    };
    self.GetLinkHtml = function (opts, lnkStgs) {
        return getLinkHtml(opts, lnkStgs);
    };

    let markPending = false;
    function markEditableFormatLabels() {
        if (markPending) return;
        markPending = true;
        setTimeout(function () {
            markPending = false;
            $(".has-ex-format-editable").each(function () {
                $(this).parents('.form-group').find('>div:first-child').addClass('focused-hard');
            });
        }, 0);
    }

    function getFormattingRulesHtml(opts, item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        let classes = "";
        let style = "";
        let tooltip = "";
        let res = false;
        const formatRules = opts.settings.items || [];
        let selector = "#entity-grid-" + opts.nodeId;
        let modelName = null;
        let $cont = $(selector);
        if ($cont.length) {
            modelName = XPortal.Store.getGridModelName($cont);
        }
        else {
            selector = "#detail-page-" + opts.nodeId;
            $cont = $(selector);
            modelName = $cont.length ? XPortal.Store.getModelName($cont) : null;
        }
        if (fOpts && fOpts.modelName) modelName = fOpts.modelName;
        if (!modelName) return;
        const model = Object.assign({}, opts.item, { ModelName: modelName, NodeId: opts.nodeId });
        XPortal.SectionDisplayRules.updateRelatedModel(model.ModelName, formatRules, selector);
        formatRules.forEach(r => {
            let rulesResult = false;
            if (r.IsEnabled && r.Rules && r.Rules.length)
                rulesResult = XPortal.SectionDisplayRules.Processing.areRulesTrue(model, [...r.Rules], null, true, true);

            if (rulesResult) {
                classes = classes + " " + r.CssClasses;
                style = style + (style.length ? "; " : "") + r.StyleCss;
                const rTooltip = processTemplate(r.Tooltip, null, item, opts.nodeId, dfield);
                tooltip = tooltip + " " + rTooltip;
                res = true;
            }
        });
        tooltip = tooltip.trim();
        const htmlTooltip = tooltip && tooltip.length && res ? `<a href="javascript:void(0)" title="${tooltip}" class="tooltip fr-tooltip"><i class="icon-question"></i></a>` : "";
        let html = '';
        opts.settings.formula = opts.settings.title;
        const procTitle = self.Custom(item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) || "";
        if (!style.length && !classes.length && !htmlTooltip.length) {
            // in case formatting rule disabled or no rules applied return just tittle
            html = procTitle;
        } else {

            if (!procTitle.trim().length && !htmlTooltip.trim().length) {
                style = '';
                classes = '';
            }
            html = `<div class="${classes} conditional-formated-value" style="${style}"><span class="conditional-formated-value__text">${procTitle}</span> ${htmlTooltip}</div>`;
        }
        html = processTemplate(html, null, opts.item, opts.nodeId, opts.dfield);

        markEditableFormatLabels();

        return html;
    };
    function getFieldSettings(dfield, inFormat, nodeId, item, fOpts) {
        var res = {
            item, nodeId,
            dfield: dfield ? decodeURIComponent(dfield) : dfield,
            inFormat: inFormat ? decodeURIComponent(inFormat) : inFormat,
            settings: null
        };
        var dsFormat = fOpts ? fOpts : XPortal.Grid.ExtendedFormat(nodeId, dfield);
        res.settings = dsFormat && dsFormat.formatExtended ? dsFormat.formatExtended.Settings : null;
        return res;
    };
    function getAlertModel(opts) {
        var r = Object.assign({}, opts.settings);
        r.showCount = r.showCount || 2;
        r.showAllText = r.showMoreText || "Show more";
        r.showLessText = r.showLessText || "Show less";
        r.noAlertsMsg = r.noAlertsMsg || "No alerts to show";
        r.items.forEach(v => {
            const fcode = XPortal.Template.ProcessFormula(v.formula, opts.item, opts.nodeId, opts.dfield);
            try {
                v.data = v.value = contains(fcode, "=", ">", "<", "!", "+", "-", "*", "/", "") ? new Function('return ' + fcode)() : fcode;
            } catch (e) {
                v.data = v.value = fcode;
            }
            v.count = isNaN(Number(v.value)) ? 0 : Number(v.value);
            v.visible = v.value ? true : false;
            v.html = processTemplate(v.title, v.value, Object.assign({}, opts.item, v));
            if (v.link) v.html = getLinkHtml(opts, Object.assign({}, v.link, { title: v.html }));
        });
        r.vitems = r.items.filter(v => v.visible);
        r.count = 0;
        r.vitems.forEach((v, i) => {
            if (i >= r.showCount) v.css = "alert-show-less d-none";
            if (!isNaN(Number(v.value)) && v.value !== true && v.value !== false) r.count = r.count + Number(v.value);
            else r.count = r.count + (v.visible ? 1 : 0);
        });
        r.countwithparentheses = r.count ? `(${r.count})` : "";
        r.sum = r.count;
        r.sumwithparentheses = r.countwithparentheses;
        r.title = processTemplate(r.title, null, Object.assign({}, opts.item, r));
        r.css = r.count > 0 ? "" : "d-none";
        r.spanEmptyCss = r.vitems.length ? "d-none" : "";
        r.showAllBtnCss = r.showCount < r.vitems.length ? "" : "d-none";
        r.showLessBtnCss = "d-none";
        return r;
    };
    function getPercentModel(opts) {
        var r = Object.assign({}, opts.settings);
        r.vitems = _.sortBy(r.points || [], p => p.maxVal);
        pmax = null;

        const fcode = XPortal.Template.ProcessFormula(r.formula, opts.item, opts.nodeId, opts.dfield);
        try {
            r.value = Number(contains(fcode, "+", "-", "*", "/", "") ? new Function('return ' + fcode)() : fcode);
        } catch (ex) {
            r.value = fcode;
        }
        r.value = r.data = isNaN(r.value) ? 0 : r.value;
        r.maxVal = XPortal.Utils.parseNumber(XPortal.Template.ProcessFormula(r.maxVal, opts.item));
        r.percent = Math.round(r.maxVal > 0 ? 100 * (r.value / r.maxVal) : r.value);

        var autoColor;
        if (r.percent >= 100) {
            autoColor = 'MediumSeaGreen';
        } else if (r.percent >= 30) {
            autoColor = 'Orange';
        } else {
            autoColor = 'DodgerBlue';
        }

        r.bgcolor = r.bgcolor || autoColor;
        var rBg = /^[0-9A-Fa-f]{3,8}$/.test(r.bgcolor) ? '#' + r.bgcolor : r.bgcolor;
        var rTxt = r.color && /^[0-9A-Fa-f]{3,8}$/.test(r.color) ? '#' + r.color : r.color;

        r.defHtml = '<div class="progress-bar__wrapper">' + '<div class="progress-bar__bg">' + '<div class="dynamic-bar" style="background-color:' + rBg + '; width:calc([[percent]]%);"></div>' + '</div>' + '<span class="progress-bar__text" style="color:' + rTxt + ';">[[title]]</span>' + '</div>';

        r.vitems.forEach(v => {
            v.min = pmax;
            v.bgcolor = v.bgcolor || (r.bgcolor || autoColor);
            v.color = v.color || r.color;

            var bg = /^[0-9A-Fa-f]{3,8}$/.test(v.bgcolor) ? '#' + v.bgcolor : v.bgcolor;
            var txt = v.color && /^[0-9A-Fa-f]{3,8}$/.test(v.color) ? '#' + v.color : v.color;

            v.html = '<div class="progress-bar__wrapper">' + '<div class="progress-bar__bg">' + '<div class="dynamic-bar" style="background-color:' + bg + '; width:calc([[percent]]%);"></div>' + '</div>' + '<span class="progress-bar__text" style="color:' + txt + ';">[[title]]</span>' + '</div>';

            v.maxVal = pmax = XPortal.Utils.parseNumber(v.maxVal);
            v.value = 0;
            v.title = v.title || r.title;
        });

        r.css = r.percent > 0 ? "" : "d-none";
        return r;
    };
    function getTrendingModel(opts) {
        var r = Object.assign({}, opts.settings);
        r.current = isNaN(Number(r.current)) ? 0 : Number(r.current);
        r.previous = isNaN(Number(r.previous)) ? 0 : Number(r.previous);
        r.decimals = isNaN(Number(r.decimals)) || Number(r.decimals) < 0 ? 0 : Number(r.decimals);

        if ((r.type || "").toLowerCase() == "difference") r.value = r.current - r.previous;
        else if (r.previous == 0) r.value = r.current == 0 ? 0 : 100; //nothing to compare with: anything above nothing is a full gain
        else r.value = 100 * (r.current - r.previous) / Math.abs(r.previous);

        const factor = Math.pow(10, r.decimals);
        r.value = Math.round(r.value * factor) / factor;

        r.abs = Math.abs(r.value);
        r.direction = r.value > 0 ? "trend-up" : (r.value < 0 ? "trend-down" : "trend-flat");

        //rules are kept in the configured order and the first matching one wins, as for the tile conditional formatting
        r.vitems = r.items || [];
        r.defHtml = (r.type || "").toLowerCase() == "difference" ? "[[value]]" : "[[value]]%";
        r.tooltip = r.tooltip || "";
        return r;
    };
    //a rule matches when the trend value satisfies every one of its 1-2 conditions (ANDed, the same way a range used to AND a lower and an upper bound)
    function isTrendInRule(rule, value) {
        const conditions = (rule || {}).conditions || [];
        if (!conditions.length) return false;
        return conditions.every(c => matchesTrendCondition(value, c.op, c.value));
    };
    function matchesTrendCondition(value, op, threshold) {
        threshold = Number(threshold);
        switch (op) {
            case ">": return value > threshold;
            case "<": return value < threshold;
            case ">=": return value >= threshold;
            case "<=": return value <= threshold;
            default: return value == threshold;
        }
    };
    function toCssColor(color) {
        if (!color || !color.length) return null;
        return /^[0-9A-Fa-f]{3,8}$/.test(color) ? "#" + color : color;
    };
    function getLinkHtml(opts, lnkStgs) {
        let lTitle = processTemplate(lnkStgs.title || opts.settings.title, null, opts.item, opts.nodeId, opts.dfield);
        const lUrl = processTemplate(lnkStgs.url || opts.settings.url, null, opts.item, opts.nodeId, opts.dfield);
        const lQuery = lnkStgs.query || opts.settings.query ? processTemplate(lnkStgs.query || opts.settings.query, null, opts.item, opts.nodeId, opts.dfield) : "";
        const lQueryStart = lQuery && lQuery.length && lQuery.substring(0, 1) != "?" ? "?" : "";
        const lTarget = opts.settings.target || lnkStgs.target ? opts.settings.target || lnkStgs.target : "_self";
        const res = $('<span><a href="' + lUrl + lQueryStart + lQuery + '">-</a></span>');
        const iLink = res.find("a");
        const readyHref = iLink.attr("href");
        if (readyHref.length == 0 && opts.settings.dialog == undefined) {
            lTitle = "";
        }
        iLink.html(lTitle);
        iLink.attr("target", lTarget);
        iLink.attr("data-sttgs", JSON.stringify(lnkStgs && Object.keys(lnkStgs).length ? lnkStgs: (opts.settings)));
        if (opts.settings.cssClass) iLink.addClass(opts.settings.cssClass);
        if (opts.settings.track) iLink.attr("data-activity", "link click");
        if (lTarget.toLowerCase() == "_popup") iLink.addClass("open-in-dialog");
        return res.html();
    }
    function contains(d, ...args) {
        return args.find(a => d.indexOf(a) > -1) ? true : false;
    };
    function processTemplate(inFormat, fvalue, doc, nodeId, dfield) {
        var res = inFormat;
        if (inFormat && (inFormat.indexOf("[[") >= 0 || inFormat.indexOf("##") >= 0))
            res = XPortal.Template.ReplaceFormatString(inFormat, fvalue, doc, nodeId, dfield);
        if (res && (res.indexOf("#=") >= 0 || res.indexOf("#:") >= 0))
            res = XPortal.Template.ApplyKendoTemplate(doc, res);
        return res;
    };
    let valueSeparatorSrc = null;
    let valueSeparatorRe = null;
    function getValueSeparatorRegExp() {
        const sep = XPortal.GridInlineEditing.ValueSeparator;
        if (valueSeparatorSrc !== sep) {
            valueSeparatorSrc = sep;
            valueSeparatorRe = new RegExp(sep, "g");
        }
        return valueSeparatorRe;
    };
    function fSizeFormating(bytes, decimalPoint, sizesList) {
        const sizes = sizesList ? sizesList : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        if (bytes == 0) return '0 ' + sizes[0];
        var k = 1000,
            dm = decimalPoint || 2,
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    //{"title":"Show file as image", "value":"XPortal.Format.ShowAsImage(value, item, dtype, dfield, fOpts,'', true, imageFieldName);", "description":"Show value as image taken from the specified field."}
    self.ShowAsImage = function (value, item, dtype, dfield, fOpts, style, noPreview, imageFieldName) {
        if (!value || value.length == 0)
            return value;
        var graphExts = ['gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg'];
        var isFileGraphic = graphExts.includes(item.fileextension);

        var noImageUrl = !isFileGraphic || noPreview ? "/content/images/icons/file_types/" + item.fileextension.replaceAll('.', '') + ".png" : "/content/images/empty-content-view-item.png";
        var fval = XPortal.Template.GetObjPropValueByName;
        if (isFileGraphic && (imageFieldName || (fOpts && fOpts.field)))
            var propVal = fval(item, imageFieldName ? imageFieldName : fOpts.field);
        var iurl = propVal == null || noPreview ? noImageUrl : encodeURIComponent(propVal);
        var ialias = fval(item, "alias");
        ialias = ialias ? ialias : fval(item, "entityalias");
        var purl = propVal == null || noPreview ? iurl : "/umbraco/Surface/Detail/ImageAltr?i=" + fval(item, "UniqueId") + "&a=" + ialias + "&src=&cnfr=1&file=" + iurl + "&f=Image&altr=" + noImageUrl;
        var r = $("<img/>");
        r.attr("src", purl);
        r.attr("alt", value);
        if (style && style.length > 0)
            r.attr("style", style)
        return $("<div/>").append(r).html();
    };
    //{"title":"Show as file download", "value":"XPortal.Format.linkToDownload(value, item, dfield, nodeId);", "description":"Render html link to download file"}
    self.linkToDownload = function (value, item, dfield, nodeId) {
        var customFormat = '<a class="download" href="/umbraco/Surface/Detail/DownloadAllAttachments?id=#=item.UniqueId#&KeyField=#=fname#&NodeId=[[nodeId]]&pinfo=#: details.parentInfo #" target="downloadFrm" title="#=title#">#=title#</a>';
        return XPortal.Template.base64(customFormat, value = Array.isArray(value) ? value : [value], item, dfield, nodeId);
    };

    //{"title":"Convert file size to readable value", "value":"XPortal.Format.FormatFileSize(value,'Byte|KB|MB|GB|TB');", "description":"Convert value to value with a unit of measure."}
    self.FormatFileSize = function (val, sizesList) {
        if (!val || val == null) return '';
        sizesList = sizesList.split('|');
        if (!isNaN(val))
            return fSizeFormating(val, 2, sizesList);
        return val;
    };

    //{"title":"Replace value", "value":"XPortal.Format.ReplaceByExpression(value,'fromExpression','toExpression');", "description":"Replace value according to an expression."}
    self.ReplaceByExpression = function (value, from, to) {
        if (!value || value.length == 0 || !from || !to)
            return value;
        return value.toString().replaceAll(from, to);
    };
    //{"title":"Replace value depends of expression", "value":"XPortal.Format.ReplaceByExpressionBoth(value,'fromExpression','toExpression','falseexpresion');", "description":"Replace value according to an expression."}
    self.ReplaceByExpressionBoth = function (value, from, to, falsefrom) {
        if (!value || value.length == 0 || !from || !to) {
            if (falsefrom) return falsefrom;
            return value;
        }
        return value.toString().replaceAll(from, to);
    };

    //{"title":"Look up value", "value":"XPortal.Format.ConditionDisplay(value, item, 'value condition');", "description":"Look up value from a static list specified in the expression."}
    self.ConditionDisplay = function (value, item, condition) {
        if (!value || value.length == 0 || !item || !condition || condition.length == 0)
            return value;

        var conditionList = condition.split('|');
        if (conditionList.length == 0)
            return value;

        var condList = {};
        conditionList.forEach(function (c) {
            var cTmp = c.split(':');
            if (cTmp.length < 2)
                return;
            condList[cTmp[0]] = cTmp[1];
        });

        if (condList[value]) {
            var propVal = XPortal.Template.GetObjPropValueByName(item, condList[value]);
        }
        return propVal ? propVal : value;
    };
    //{"title":"Trim concatenated field value", "value":"XPortal.Format.TrimSeparators(context,'[[field1]], [[field2]], [[field3]]',   ',');", "description":"Remove empty values, including the nearby separator (the comma (,) by default), from a concatenated value (a combination of multiple field values). If you need to remove another separator, specify it as a 3rd parameter (for example: , \";\" or , \"-\").","toreplace":"'[[field1]], [[field2]], [[field3]]'"}
    self.TrimSeparators = function (context, str, separator) {
        separator = (separator || ',').trim();
        const item = context.item;
        if (!str || !str.length) return str;
        str = str.trim();
        const r = '\\[\\[([^\\]]*)]]\\s*\\' + separator + '*\\s*';
        if (new RegExp(r, "gm").exec(str) == null) {
            if (context.opts) context.opts.isRawRequeired = true;
            return str;
        }
        let suffix = "";
        const result =
            getTrimPrefix(str, r, item, s => str = s) +
            getTrimItems(str, r, item, s => suffix = s, separator + " ") +
            suffix;
        return result;
    };
    // {"title":"SLA clock (HH:MM)", "value":"XPortal.Format.SLAClock(context,'SLAClockStart','SLAClockStop','SLAClockTotal','09:00','17:00',['01.01','04.12','04.13','06.28','06.29','07.15','08.24','12.25']);", "description":"Return End-Start as HH:MM. If Stop is empty -> uses now. If work hours provided - counts only business minutes (Mon-Fri, work window, excluding holidays). If roundup is true returns HH rounded up."}
    self.SLAClock = function (context, startField, stopField, totalField, workStart, workEnd, holArr, roundUp) {
        const item = (context && context.item) ? context.item : context;
        startField = startField || 'SLAClockStart';
        stopField = stopField || 'SLAClockStop';
        totalField = totalField || 'SLAClockTotal';

        const totalRaw = totalField ? (XPortal.Template.GetObjPropValueByName(item, totalField) || item[totalField.toLowerCase()]) : null;
        const totalMinutesAccumulated = parseTimeToMinutes(totalRaw);
        const startRaw = XPortal.Template.GetObjPropValueByName(item, startField) || item[startField.toLowerCase()];
        if (!startRaw) return totalMinutesAccumulated > 0 ? (roundUp ? formatRoundedHours(totalMinutesAccumulated) : formatHHmm(totalMinutesAccumulated)) : '';
        const endRaw = XPortal.Template.GetObjPropValueByName(item, stopField) || item[stopField.toLowerCase()] || XPortal.Utils.AdjustDT(new Date(), true);
        if (!endRaw) return '';

        const start = toDate(startRaw);
        const end = toDate(endRaw);
        if (!start || !end) return '';

        if (!workStart || !workEnd) {
            let diffMs = end - start;
            if (diffMs < 0) diffMs = 0;
            const totalMinutes = Math.floor(diffMs / 60000) + totalMinutesAccumulated;
            return roundUp ? formatRoundedHours(totalMinutes) : formatHHmm(totalMinutes);
        }

        const wsMin = parseTimeToMinutes(workStart);
        const weMin = parseTimeToMinutes(workEnd);

        if (wsMin == null || weMin == null || weMin <= wsMin) {
            let diffMs = end - start;
            if (diffMs < 0) diffMs = 0;
            const totalMinutes = Math.floor(diffMs / 60000) + totalMinutesAccumulated;
            return roundUp ? formatRoundedHours(totalMinutes) : formatHHmm(totalMinutes);
        }

        const hol = normalizeHolidays(holArr || []);

        const totalBusinessMinutes = calcBusinessMinutes(start, end, wsMin, weMin, hol);
        const totalMinutes = totalBusinessMinutes + totalMinutesAccumulated;
        return roundUp ? formatRoundedHours(totalMinutes) : formatHHmm(totalMinutes);

        // ---- helpers ----

        function calcBusinessMinutes(startDt, endDt, workStartMin, workEndMin, holNorm) {
            if (endDt < startDt) return 0;

            const fullDayMinutes = workEndMin - workStartMin;

            const sDay = new Date(startDt.getFullYear(), startDt.getMonth(), startDt.getDate());
            const eDay = new Date(endDt.getFullYear(), endDt.getMonth(), endDt.getDate());

            // if start/end in one day
            if (sameDay(sDay, eDay)) { // if one day [startDate...endDate]
                if (isWeekend(sDay) || isHoliday(sDay, holNorm)) return 0;
                return overlapMinutes(startDt, endDt, sDay, workStartMin, workEndMin);
            }

            let total = 0;
            // first (incomplete) day
            if (!isWeekend(sDay) && !isHoliday(sDay, holNorm)) {
                const dayEnd = dateAtMinutes(sDay, workEndMin); // get the end time of the working day and calculate [startDt..dayEnd]
                total += overlapMinutes(startDt, dayEnd, sDay, workStartMin, workEndMin);
            }

            // full days
            const mid = new Date(sDay);
            mid.setDate(mid.getDate() + 1);

            while (mid < eDay) {
                if (!isWeekend(mid) && !isHoliday(mid, holNorm)) {
                    total += fullDayMinutes;
                }
                mid.setDate(mid.getDate() + 1);
            }

            // last (incomplete) day
            if (!isWeekend(eDay) && !isHoliday(eDay, holNorm)) {
                const dayStart = dateAtMinutes(eDay, workStartMin);
                total += overlapMinutes(dayStart, endDt, eDay, workStartMin, workEndMin);
            }

            return Math.max(0, total);

            // ---- helpers ----
            function sameDay(a, b) {
                return a.getFullYear() === b.getFullYear() &&
                    a.getMonth() === b.getMonth() &&
                    a.getDate() === b.getDate();
            }

            function dateAtMinutes(day, minutesFromMidnight) {
                const d = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0);
                d.setMinutes(minutesFromMidnight);
                return d;
            }

            // intersection of the interval [a..b]
            function overlapMinutes(a, b, day, wsMin, weMin) {
                const winStart = dateAtMinutes(day, wsMin);
                const winEnd = dateAtMinutes(day, weMin);

                const segStart = a > winStart ? a : winStart;
                const segEnd = b < winEnd ? b : winEnd;

                if (segEnd <= segStart) return 0;
                return Math.floor((segEnd - segStart) / 60000);
            }
        }

        function normalizeHolidays(arr) {
            const mdSet = new Set(); // expected MM.dd format

            (arr || []).forEach(h => {
                if (!h) return;

                const s = String(h).trim();
                if (!s) return;

                const parts = s.split('.');
                if (parts.length !== 2) return; // not expected MM.dd.YYYY or something

                const mm = parseInt(parts[0], 10);
                const dd = parseInt(parts[1], 10);
                if (!Number.isFinite(mm) || !Number.isFinite(dd)) return;

                if (mm < 1 || mm > 12) return;
                if (dd < 1 || dd > 31) return;

                mdSet.add(String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0'));
            });

            return { mdSet };
        }

        function isHoliday(date, holNorm) {
            if (!holNorm) return false;
            const md = mdKey(date); // "MM-DD"
            return holNorm.mdSet.has(md); // normilize for (new Date(2026, 11, 25) -> true (12-15))
        }

        function isWeekend(d) {
            const wd = d.getDay(); // 0 Sun .. 6 Sat
            return wd === 0 || wd === 6;
        }

        function mdKey(d) {
            const MM = pad2(d.getMonth() + 1);
            const dd = pad2(d.getDate());
            return `${MM}-${dd}`; // normilize value for month
        }

        function pad2(n) {
            n = isNaN(n) ? 0 : n;
            return String(n).padStart(2, "0"); // pad2(1) = 09
        }

        function parseTimeToMinutes(v) {
            if (!v) return null;
            if (typeof v === "number") return v;
            const s = String(v).trim();
            const m = /^(\d{1,2}):(\d{2})$/.exec(s);
            if (!m) return null;
            const hh = parseInt(m[1], 10);
            const mm = parseInt(m[2], 10);
            if (isNaN(hh) || isNaN(mm)) return null;
            return hh * 60 + mm;
        }

        function formatHHmm(totalMinutes) {
            totalMinutes = Math.max(0, totalMinutes | 0);
            const hh = Math.floor(totalMinutes / 60);
            const mm = totalMinutes % 60;
            return String(hh).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
        }

        function formatRoundedHours(totalMinutes) {
            totalMinutes = Math.max(0, totalMinutes | 0);
            return String(Math.round(totalMinutes / 60));
        }

        function toDate(v) {
            if (!v) return null;

            // вже Date
            if (v instanceof Date) return isNaN(v.getTime()) ? null : v;

            // timestamp
            if (typeof v === "number") {
                const d = new Date(v);
                return isNaN(d.getTime()) ? null : d;
            }

            const s = String(v).trim();
            if (!s) return null;

            // /Date(1700000000000)/
            const md = /\/Date\((\-?\d+)\)\//.exec(s);
            if (md) {
                const d = new Date(parseInt(md[1], 10));
                return isNaN(d.getTime()) ? null : d;
            }

            // "M/D/YYYY h:mm:ss AM/PM"  -> як у тебе: "1/19/2026 11:47:32 AM"
            const mUS = /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)$/i.exec(s);
            if (mUS) {
                const month = parseInt(mUS[1], 10) - 1;
                const day = parseInt(mUS[2], 10);
                const year = parseInt(mUS[3], 10);
                let hour = parseInt(mUS[4], 10);
                const min = parseInt(mUS[5], 10);
                const sec = parseInt(mUS[6], 10);
                const ap = mUS[7].toUpperCase();

                if (ap === "PM" && hour < 12) hour += 12;
                if (ap === "AM" && hour === 12) hour = 0;

                const d = new Date(year, month, day, hour, min, sec);
                return isNaN(d.getTime()) ? null : d;
            }

            const d1 = new Date(s);
            if (!isNaN(d1.getTime())) return d1;

            return null;
        }
    };


    // {"title":"SLA clock percent", "value":"XPortal.Format.SLAClockPercent(context,'SLAClockStart','SLAClockStop','SLAClockTotal','SLAResolutionTime','09:00','17:00',['01.01','04.12','04.13','06.28','06.29','07.15','08.24','12.25']);", "description":"Returns (elapsed business hours / SLA target hours) * 100 as a rounded integer."}
    self.SLAClockPercent = function (context, startField, stopField, totalField, slaTargetField, workStart, workEnd, holArr) {
        const item = (context && context.item) ? context.item : context;
        const hoursStr = self.SLAClock(context, startField, stopField, totalField, workStart, workEnd, holArr, true);
        if (!hoursStr || hoursStr === '') return '';
        const elapsedHours = parseFloat(hoursStr);
        if (isNaN(elapsedHours)) return '';

        const slaTargetRaw = XPortal.Template.GetObjPropValueByName(item, slaTargetField) || item[slaTargetField.toLowerCase()];
        const slaTargetHours = parseFloat(slaTargetRaw);
        if (isNaN(slaTargetHours) || slaTargetHours <= 0) return '';
        return Math.round((elapsedHours / slaTargetHours) * 100);
    };

    // {"title":"PlannedDeliveryDate calc", "value":"XPortal.Format.PlannedDeliveryDateCalc(context,'OnHoldClockStart','OnHoldClockStop','OnHoldClockTime','09:00','17:00',['01.01','04.12','04.13','06.28','06.29','07.15','08.24','12.25']);", "description":"PlannedDeliveryDate calc"}
    self.PlannedDeliveryDateCalc = function (context, startField, stopField, totalField, workStart, workEnd, holArr, roundUp) {
        const item = (context && context.item) ? context.item : context;
        let res = "";
        if (item["type"].toLowerCase() == "request") return item["planneddeliverydate"] && XPortal.GridActions.IsDateValue(item["planneddeliverydate"]) ? moment(item["planneddeliverydate"]).format('MM/DD/YYYY') : "";

        let slaResolutionTime = parseFloat(item["slaresolutiontime"] || "0");
        if (isNaN(slaResolutionTime) || slaResolutionTime <= 0) slaResolutionTime = 0;


        let onHoldHoursStr = self.SLAClock(context, startField, stopField, totalField, workStart, workEnd, holArr, true);
        if (!onHoldHoursStr || onHoldHoursStr === '') onHoldHoursStr = "0";
        let onHoldHours = parseFloat(onHoldHoursStr);
        if (isNaN(onHoldHours)) onHoldHours = 0;

        if (item["rejectioncounter"] == 0) {
            let totalHours = slaResolutionTime + onHoldHours;
            const created = item["created"];
            res = addHoursToDate(created, totalHours, workStart, workEnd, holArr);
        }
        else {
            let resolutionTimeStr = XPortal.Format.SLAClock(context, 'SLAClockStart', 'SLAClockStop', 'SLAClockTotal', '09:00', '17:00', ['01.01', '04.12', '04.13', '06.28', '06.29', '07.15', '08.24', '12.25'], true);
            if (!resolutionTimeStr || resolutionTimeStr === '') resolutionTimeStr = "0";
            let resolutionTime = parseFloat(resolutionTimeStr);
            if (isNaN(resolutionTime)) resolutionTime = 0;
            var resolutionHours = slaResolutionTime - resolutionTime;
            if (resolutionHours < 0) resolutionHours = 0;
            let totalHours = resolutionHours + onHoldHours;
            const resolved = item["responsedate"] || item["resolveddate"];
            res = addHoursToDate(resolved, totalHours, workStart, workEnd, holArr);
        }
        return res && res.isValid() ? res.format('MM/DD/YYYY') : '';
    }

    function addHoursToDate(created, totalHours, workStart, workEnd, holArr) {

        let dt = moment(created);

        const [startHour, startMinute] = workStart.split(':').map(Number);
        const [endHour, endMinute] = workEnd.split(':').map(Number);

        moveToWorkingTime(dt);

        while (totalHours > 0) {

            const endOfDay = dt.clone()
                .hour(endHour)
                .minute(endMinute)
                .second(0)
                .millisecond(0);

            const availableHoursToday = Math.floor(
                moment.duration(endOfDay.diff(dt)).asHours()
            );

            if (totalHours <= availableHoursToday) {
                dt.add(totalHours, 'hours');
                return dt;
            }

            totalHours -= availableHoursToday;

            dt = nextWorkingDay(dt, startHour, startMinute);
        }

        return dt;

        function moveToWorkingTime(date) {

            while (isNonWorkingDay(date)) {
                date.add(1, 'day')
                    .hour(startHour)
                    .minute(startMinute)
                    .second(0)
                    .millisecond(0);
            }

            const currentMinutes = date.hour() * 60 + date.minute();
            const workStartMinutes = startHour * 60 + startMinute;
            const workEndMinutes = endHour * 60 + endMinute;

            if (currentMinutes < workStartMinutes) {
                date.hour(startHour)
                    .minute(startMinute)
                    .second(0)
                    .millisecond(0);
            }
            else if (currentMinutes >= workEndMinutes) {
                date.add(1, 'day')
                    .hour(startHour)
                    .minute(startMinute)
                    .second(0)
                    .millisecond(0);

                while (isNonWorkingDay(date)) {
                    date.add(1, 'day');
                }
            }
        }

        function nextWorkingDay(date, startHour, startMinute) {

            const next = date.clone()
                .add(1, 'day')
                .hour(startHour)
                .minute(startMinute)
                .second(0)
                .millisecond(0);

            while (isNonWorkingDay(next)) {
                next.add(1, 'day');
            }

            return next;
        }

        function isNonWorkingDay(date) {

            if (date.day() === 0 || date.day() === 6) {
                return true;
            }

            return holArr.indexOf(date.format('MM.DD')) >= 0;
        }
    }
    function getTrimPrefix(strToProcess, regex, item, onTrim) {
        ritems = new RegExp(regex, "gm").exec(strToProcess);
        if (!ritems || !ritems.length) return "";
        onTrim(strToProcess.substr(ritems.index));
        return strToProcess.substr(0, ritems.index);
    };
    function getTrimItems(strToProcess, regex, item, onSuffix, separator) {
        const res = [];
        let pstr = strToProcess;
        do {
            ritems = new RegExp(regex, "gm").exec(pstr);
            if (ritems && ritems.length) {
                const suffix = processTemplate("[[" + ritems[1] + "]]", null, item);
                const prefix = pstr.substr(0, ritems.index);
                if (!XPortal.Utils.htmlIsEmpty(suffix)) {
                    res.push(prefix + suffix);
                }
                pstr = pstr.substr(ritems.index + ritems[0].length);
            }
        } while (ritems && ritems.length);
        onSuffix(pstr || "");
        return res.join(separator);
    };

    function processFunction(context) {
        const opts = context.opts;
        opts.isRawRequeired = false;
        const funcString = processTemplate(opts.settings.formula, null, context.item, context.nodeId, context.dfield);

        let func = new Function('context', 'with(context){\r\n     return ' + funcString + '; \r\n    }');

        let fres = func.call(context, context);
        if (!opts.isRawRequeired) return fres;
        //possibility to send template as part of function query and process template directly in it
        func = new Function('context', 'with(context){\r\n     return ' + opts.settings.formula + '; \r\n    }');

        return func.call(context, context);
    };
    return self;
}());


//{"title":"Configure how empty value is displayed", "value":"XPortal.Format.ReplaceByExpressionBoth(value,value,value,'No data');", "description":"Set up how the empty value is displayed. By default, the empty value with this expression is displayed as 'No data', which can be changed to the one that you want to be displayed. For example: 'Empty', 'Null' or '-'"}

//{"title":"Configure how boolean value is displayed", "value":"XPortal.Format.ReplaceByExpressionBoth(value,/true|1/g,'Yes','No');", "description":"Set up how the boolean value is displayed. Replace the default values ('true' or 'false') to the ones that you want to be displayed. For example: 'Yes' or 'No', 'On' or 'Off'."}
